<template>
    <div>
        <!-- 产品banner -->
        <div class="cp_ban">
            <div class="cp_tp"
                :style="{ backgroundImage: (productInfo.dtimg == null || productInfo.dtimg == '') ? `url(https://cdn.bosscaigou.com/${productInfo.himg})` : `url(https://cdn.bosscaigou.com/${productInfo.dtimg})` }">
            </div>
            <div class="dq_lm">
                <div class="container">
                    <div class="l_m"><i class="iconfont icon-dizhi1"></i> <a href="/">Home</a> - <a
                            href="/products">Products</a></div>
                </div>
            </div>
            <div class="cp_mc">
                <div class="container">
                    <h1 style="width: 75%;">{{ productInfo.name }}</h1>
                </div>
            </div>
        </div>

        <!-- 产品介绍 -->
        <div class="cp_jj">
            <div class="container">
                <div class="row">
                    <!-- 修改：将视频区域改为可点击的容器 -->
                    <div class="js_sp video-container" @click="openVideoModal(productInfo.video || productInfo.video2)">
                        <!-- 视频封面图 -->
                        <div class="video-cover">
                            <img :src="`https://cdn.bosscaigou.com/${productInfo?.vh1 || productInfo.himg}`"
                                alt="Video cover" class="cover-img">
                            <div class="play-icon"><i class="iconfont icon-bofang"></i></div>
                        </div>
                        <!-- 隐藏原视频元素 -->
                        <!-- <video width="100%" controls controlslist="nodownload" webkit-playsinline="" playsinline=""
                            x5-playsinline="" x-webkit-airplay="allow"
                            :poster="`https://cdn.bosscaigou.com/${productInfo?.vh1 || productInfo.himg}`"
                            style="display: none;">
                            <source :src="`https://cdn.bosscaigou.com/${productInfo.video || productInfo.video2}`"
                                type="video/mp4">
                        </video> -->
                    </div>
                    <div class="wz_js">
                        <div class="b_t">Description</div>
                        <div class="j_s" style="max-height: 250px;overflow-y: auto;white-space: break-spaces;">{{
                            productInfo.detail }}</div>
                        <div class="a_n">
                            <a href="#tj_bd" class="z_x"><i class="iconfont icon-youxiang1"></i>Contact Us</a>
                            <!-- <a href="#sp_zs" v-show="productInfo.video != '' && productInfo.video != null" class="s_p"
                                @click="openVideoModal(productInfo.video || productInfo.video2)"><i
                                    class="iconfont icon-bofang"></i>Play Video</a> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 产品特点 -->
        <div class="cp_ys">
            <div class="container">
                <div class="ys_bt">Features</div>
                <div class="row">
                    <div class="ys_js">
                        <div class="w_z">{{ productInfo.dt1 }}</div>
                        <div class="y_s">
                            <ul>
                                <li id="btn1" v-for="(item, index) in teseOptions" :key="index"
                                    @mouseenter="swiperSlideTo(item.txt.includes('@') ? index : -1)">
                                    <h3 v-if="item.txt.includes('@')">
                                        {{ item.txt.split('@')[0] }}
                                        <i class="iconfont icon-zuojiantou"></i>
                                    </h3>

                                    <!-- 统一显示 p，内容自动判断 -->
                                    <p
                                        :style="{ 'display': item.txt.includes('@') ? (nowTese == index ? 'block !important' : 'none') : 'block !important' }">
                                        <span v-if="item.txt.includes('@')">{{ item.txt.split('@')[1] }}</span>
                                        <span v-else>{{ item.txt }}</span>
                                    </p>
                                    <!-- <img src="/images/cp2_1.jpg" alt="" title=""> -->
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="ys_tp">
                        <div class="swiper-container swiper-ys">
                            <div class="swiper-wrapper">
                                <div class="swiper-slide" v-for="(item, index) in productInfo?.img || []" :key="index">
                                    <img :src="`https://cdn.bosscaigou.com/${item}`" alt="" title="">
                                </div>
                            </div>
                            <div class="swiper-pagination"></div>
                            <div class="swiper-button-prev" @click="swiperYs.slidePrev()"><i
                                    class="iconfont icon-youjiantou"></i></div>
                            <div class="swiper-button-next" @click="swiperYs.slideNext()"><i
                                    class="iconfont icon-zuojiantou"></i></div>
                        </div>
                        <!-- <div class="swiper-button-prev"><i class="iconfont icon-zuojiantou"></i></div>
                        <div class="swiper-button-next"><i class="iconfont icon-zuojiantou"></i></div> -->
                    </div>
                </div>
            </div>
        </div>

        <!-- 产品规格 -->
        <div class="cp_cs" v-show="canshuOptions.length > 0">
            <div class="container">
                <div class="cs_bt">Specifications</div>
                <div class="cs_zs">
                    <ul>
                        <li v-for="canshu in canshuOptions" :key="canshu.id">
                            <div class="m_c">{{ canshu.name }}</div>
                            <div class="c_s">{{ canshu.content }}</div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <!-- 产品视频&联系表单 -->
        <div class="cp_sp" id="sp_zs">
            <div class="container">
                <div class="sp_bt" v-show="productInfo.video2 != '' && productInfo.video2 != null">Application Video
                </div>
                <div class="bt_wz" v-show="productInfo.video2 != '' && productInfo.video2 != null">{{ productInfo.dt2 }}
                </div>
                <!-- 修改：将视频区域改为可点击的容器 -->
                <div class="video video-container" v-show="productInfo.video2 != '' && productInfo.video2 != null"
                    style="margin-bottom: 90px;" @click="openVideoModal(productInfo.video2 || productInfo.video)">
                    <!-- 视频封面图 -->
                    <div class="video-cover">
                        <img :src="`https://cdn.bosscaigou.com/${productInfo?.vh2 || productInfo.himg}`"
                            alt="Video cover" class="cover-img">
                        <div class="play-icon"><i class="iconfont icon-bofang"></i></div>
                    </div>
                    <!-- 隐藏原视频元素 -->
                    <!-- <video width="100%" controls controlslist="nodownload" webkit-playsinline="" playsinline=""
                        x5-playsinline="" x-webkit-airplay="allow"
                        :poster="`https://cdn.bosscaigou.com/${productInfo?.vh2 || productInfo.himg}`"
                        style="display: none;">
                        <source :src="`https://cdn.bosscaigou.com/${productInfo.video2 || productInfo.video}`"
                            type="video/mp4">
                    </video> -->
                </div>
                <div class="xq_bd" id="tj_bd">
                    <h1>Get in touch</h1>
                    <p>Our dedicated team is here to help and answer any questions you might have.<br>
                        We look forward to hearing from you, and we will do our very best to get back to you as soon
                        as
                        possible.</p>
                    <form @submit.prevent="submitForm">
                        <ul class="row">
                            <li><input type="text" placeholder="First name" v-model="form.firstName"></li>
                            <li><input type="text" placeholder="Last name" v-model="form.lastName"></li>
                            <li><input type="email" placeholder="Email" v-model="form.email"></li>
                            <li><input type="text" placeholder="Phone" v-model="form.phone"></li>
                            <li><input type="text" placeholder="Company" v-model="form.company"></li>
                            <li>
                                <select v-model="form.jobTitle">
                                    <option value="">Job title</option>
                                    <option value="C-level">C-level</option>
                                    <option value="Senior executive">Senior executive</option>
                                    <option value="Service/Maintenance">Service/Maintenance</option>
                                    <option value="Production">Production</option>
                                    <option value="Technical">Technical</option>
                                    <option value="IT">IT</option>
                                    <option value="Finance">Finance</option>
                                    <option value="Admin/Support staff">Admin/Support staff</option>
                                    <option value="Other">Other</option>
                                </select>
                            </li>
                            <li>
                                <select v-model="form.industry">
                                    <option value="">Industry</option>
                                    <option value="Poultry">Poultry</option>
                                    <option value="Meat">Meat</option>
                                    <option value="Fish">Fish</option>
                                    <option value="Other">Other</option>
                                </select>
                            </li>
                            <li>
                                <select v-model="form.country">
                                    <option value="">Country</option>
                                    <option value="Afghanistan">Afghanistan</option>
                                    <option value="China">China</option>
                                    <option value="United States of America">United States of America</option>
                                    <!-- 省略其他国家选项，保留核心示例 -->
                                </select>
                            </li>
                            <li>
                                <textarea placeholder="Message" v-model="form.message"></textarea>
                            </li>
                        </ul>
                        <button type="submit">Submit</button>
                    </form>
                </div>
            </div>
        </div>

        <!-- 相关产品 -->
        <!-- <div class="xq_tj">
            <div class="container">
                <div class="b_t">Related products</div>
                <div class="xg_tj">
                    <div class="swiper-container swiper-tj">
                        <div class="swiper-wrapper">
                            <div class="swiper-slide"><a href="">
                                    <div class="t_p"><img src="/images/cp1.jpg" alt="" title=""></div>
                                    <div class="w_z">Counterflow Evaporative Condenser</div>
                                </a></div>
                            <div class="swiper-slide"><a href="">
                                    <div class="t_p"><img src="/images/cp1.jpg" alt="" title=""></div>
                                    <div class="w_z">Counterflow Evaporative Condenser</div>
                                </a></div>
                            <div class="swiper-slide"><a href="">
                                    <div class="t_p"><img src="/images/cp1.jpg" alt="" title=""></div>
                                    <div class="w_z">Counterflow Evaporative Condenser</div>
                                </a></div>
                            <div class="swiper-slide"><a href="">
                                    <div class="t_p"><img src="/images/cp1.jpg" alt="" title=""></div>
                                    <div class="w_z">Counterflow Evaporative Condenser</div>
                                </a></div>
                        </div>
                    </div>
                    <div class="swiper-pagination"></div>
                    <div class="swiper-button-prev"><i class="iconfont icon-zuojiantou"></i></div>
                    <div class="swiper-button-next"><i class="iconfont icon-zuojiantou"></i></div>
                </div>
            </div>
        </div> -->

        <div class="xq_tj" ref="relatedProduct">
            <div class="container">
                <div class="b_t">Related products</div>
                <div class="xg_tj">
                    <div class="swiper-container swiper-tj" ref="relatedSwiper">
                        <div class="swiper-wrapper">
                            <div class="swiper-slide" v-for="(item, index) in tuijianProducts" :key="index"><a
                                    :href="`/product_xq/${item.id}`">
                                    <div class="t_p"><img :src="`https://cdn.bosscaigou.com/${item.himg}`"
                                            :alt="item.name" :title="item.name"></div>
                                    <div class="w_z"
                                        style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">{{
                                            item.name }}</div>
                                </a></div>
                        </div>
                    </div>
                    <div class="swiper-pagination"></div>
                    <div class="swiper-button-prev"><i class="iconfont icon-zuojiantou"></i></div>
                    <div class="swiper-button-next"><i class="iconfont icon-zuojiantou"></i></div>
                </div>
            </div>
        </div>


        <!-- 视频弹窗 - 修复版 -->
        <div class="video-modal" v-if="showVideoModal" @click.self="closeVideoModal">
            <div class="modal-content">
                <button class="close-btn" @click="closeVideoModal">&times;</button>
                <!-- <video ref="modalVideo" controls controlslist="nodownload" webkit-playsinline playsinline x5-playsinline
                    style="max-width: 1280px;" x-webkit-airplay="allow">
                    <source :src="nowVideo" type="video/mp4">
                </video> -->
                <div class="video-modal-view" style="max-width: 1280px;" v-html="nowVideo"></div>
            </div>
        </div>
    </div>
</template>

<script>
import Swiper from 'swiper';
import 'swiper/css/swiper.css';
import { infoProduct } from '@/api';
import { mapState } from 'vuex';
export default {
    name: 'ProductContent',
    data() {
        return {
            nowVideo: '',
            nowTese: 0,
            refreshKey: 0, // 新增：用于刷新数据
            // 导航激活态
            isProductsActive: true,
            // 搜索弹窗
            showSearch: false,
            searchKeyword: '',
            // 语言切换
            showLanguage: false,
            // 产品图片
            mainImage: '/images/null.png',
            activeThumbIndex: 0,
            // 视频弹窗
            showVideoModal: false, // 新增：控制视频弹窗显示
            videoSrc: '',
            teseOptions: [],
            // 表单提交状态
            isSubmitting: false,
            // 滚动相关
            floorElements: [],
            headerHeight: 0,
            headHHeight: 0,
            // 产品详情
            productInfo: {},
            canshuOptions: [],
            tuijianProducts: [],
            typeInfo: {},
            form: { // 表单数据
                firstName: '',
                lastName: '',
                email: '',
                phone: '',
                company: '',
                jobTitle: '',
                industry: '',
                country: '',
                message: ''
            },
            swiperYs: null, // 特点轮播实例
            swiperTj: null  // 相关产品轮播实例
        }
    },
    mounted() {

        window.scrollTo(0, 0)

        // 获取产品详情
        this.infoProductFuc();

        // 滚动监听逻辑
        window.addEventListener('scroll', this.handleScroll)
    },
    beforeDestroy() {
        // 移除滚动监听
        window.removeEventListener('scroll', this.handleScroll)
        // 关闭弹窗时暂停视频
        this.closeVideoModal()
    },
    computed: {
        ...mapState(['productTypes']),
        typeDataFive() {
            return this.productTypes.slice(0, 5);
        }
    },
    methods: {
        initSwiperYs() {
            console.log(this.$refs.relatedSwiper);

            this.swiperYs = new Swiper('.swiper-ys', {
                loop: true,
                speed: 300,
                navigation: {
                    nextEl: '.swiper-ys .swiper-button-next',
                    prevEl: '.swiper-ys .swiper-button-prev',
                },
                pagination: {
                    el: '.swiper-ys .swiper-pagination',
                    clickable: true,
                },
                // slidesPerView: 1,
                spaceBetween: 0,
                autoplay: { // 可选：自动播放
                    delay: 5000,
                    disableOnInteraction: false
                }
            })

            // 初始化特点轮播
            // this.swiperYs = new Swiper('.swiper-ys', {
            //     loop: true,
            //     speed: 1000,
            //     navigation: {
            //         nextEl: '.ys_tp .swiper-button-next',
            //         prevEl: '.ys_tp .swiper-button-prev'
            //     },
            //     on: {
            //         slideChange: () => {
            //             const index = this.swiperYs.activeIndex
            //             const $lis = document.querySelectorAll('.y_s ul li')
            //             $lis.forEach((li, idx) => {
            //                 if (idx === index) {
            //                     li.classList.add('on')
            //                     li.querySelector('p').style.display = 'block'
            //                 } else {
            //                     li.classList.remove('on')
            //                     li.querySelector('p').style.display = 'none'
            //                 }
            //             })
            //         }
            //     },
            //     autoplay: true,
            //     slidesPerView: 1,
            //     spaceBetween: 10,
            //     speed: 500
            // })


        },
        initSwiperTj() {
            // 初始化相关产品轮播
            this.swiperTj = new Swiper('.swiper-tj', {
                loop: true,
                speed: 1000,
                navigation: {
                    nextEl: '.xg_tj .swiper-button-next',
                    prevEl: '.xg_tj .swiper-button-prev'
                },
                pagination: {
                    el: '.xg_tj .swiper-pagination',
                    clickable: true
                },
                autoplay: {
                    delay: 5000,
                    stopOnLastSlide: false,
                    disableOnInteraction: false
                },
                slidesPerView: 1,
                spaceBetween: 10,
                breakpoints: {
                    641: {
                        slidesPerView: 2,
                        spaceBetween: 15
                    },
                    993: {
                        slidesPerView: 3,
                        spaceBetween: 20
                    },
                    1280: {
                        slidesPerView: 4,
                        spaceBetween: 20
                    }
                }
            })
        },
        async infoProductFuc() {
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            const data = await infoProduct({
                id: this.$route.params.id
            });
            loading.close();
            if (data.code == 200) {
                this.productInfo = data.data;
                this.productInfo.img = this.productInfo.img.split(',') || [];
                this.mainImage = `https://cdn.bosscaigou.com/${this.productInfo.img[0] || data.data.himg}`;
                this.typeInfo = data.type;
                this.teseOptions = data.data.tese || [];
                this.canshuOptions = data.data.canshu || [];
                this.tuijianProducts = data.tuijian || [];
                this.$nextTick(() => {
                    this.initSwiperYs();
                });
                this.refreshKey++;
                // this.swiperSlideTo(1)
                this.$nextTick(() => {

                    // this.swiperSlideTo(0)
                    this.initSwiperTj()

                    // 刷新数据
                });
            } else {
                this.$message({
                    message: data.message,
                    type: 'error'
                });
            }
        },
        // 轮播切换
        swiperSlideTo(index) {

            if (index == -1) {
                this.nowTese = -1;
                return;
            }

            // console.log('ceshi:', index)
            this.nowTese = index;
            this.refreshKey++;
            // this.swiperYs.slideTo(index, 500, true)
        },
        // 新增：打开视频弹窗
        openVideoModal(vi) {
            if (!vi) {
                this.$message({
                    message: 'There is no video for this product at the moment!',
                    type: 'error'
                });
                return;
            };
            this.nowVideo = vi;
            this.showVideoModal = true;
            // 等待DOM渲染完成后播放视频
            this.$nextTick(() => {
                const video = this.$refs.modalVideo;
                if (video) {
                    video.play().catch(err => {
                        console.log('自动播放失败，需要用户手动点击:', err);
                    });
                }
            });
        },
        // 新增：关闭视频弹窗
        closeVideoModal() {
            this.showVideoModal = false;
            // 暂停视频并重置播放位置
            const video = this.$refs.modalVideo;
            if (video) {
                video.pause();
                video.currentTime = 0;
            }
        },
        // 表单提交
        submitForm() {
            // 可添加表单验证和提交逻辑
            console.log('表单提交数据：', this.form)
            // 示例：提交成功提示
            alert('Form submitted successfully!')
        },
        // 滚动处理
        handleScroll() {
            const top = window.scrollY
            const cpZsTop = document.querySelector('.cp_zs')?.offsetTop || 0
            const xqTjTop = document.querySelector('.xq_tj')?.offsetTop || 0
            const headHHeight = document.querySelector('.head_h')?.offsetHeight || 0
            const lmNr = document.querySelector('.lm_nr')

            if (!lmNr) return

            const lg = cpZsTop - headHHeight - 30
            const gd = xqTjTop - (document.querySelector('.lm_nr')?.offsetHeight || 0) - headHHeight - (document.querySelector('.top')?.offsetHeight || 0) - 70

            if (top > lg) {
                lmNr.classList.add('on')
                lmNr.classList.remove('on_a')
            } else {
                lmNr.classList.remove('on')
            }

            if (top > gd) {
                lmNr.classList.remove('on')
                lmNr.classList.add('on_a')
            }
        }
    }
}
</script>

<style scoped>
/* 视频容器样式 */
.video-container {
    cursor: pointer;
    position: relative;
}

.video-modal-view {
    width: 1000px;
    height: 80%;
}

/* 视频封面样式 */
.video-cover {
    position: relative;
    width: 100%;
    height: 100%;
}

.cover-img {
    width: 100%;
    height: auto;
    display: block;
}

/* 播放按钮样式 */
.play-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 80px;
    height: 80px;
    border-radius: 50%;
    background-color: rgba(0, 0, 0, 0.1);
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 40px;
    transition: all 0.3s ease;
}

.video-container:hover .play-icon {
    background-color: rgba(0, 0, 0, 0.7);
    transform: translate(-50%, -50%) scale(1.1);
}

/* 视频弹窗样式 - 完美适配横竖屏 */
.video-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.85);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
    padding: 15px;
    box-sizing: border-box;
}

.modal-content {
    position: relative;
    width: 100%;
    height: 100%;
    /* max-width: 95%;
    max-height: 95%; */
    display: flex;
    align-items: center;
    background: unset !important;
    justify-content: center;
}

/* 核心：让视频自动缩放，永远全屏显示但不超出屏幕 */
.modal-content video {
    max-width: 100%;
    max-height: 100%;
    width: auto;
    height: auto;
    object-fit: contain;
    display: block;
}

.close-btn {
    position: absolute;
    top: 25px;
    right: 25px;
    background: rgba(0, 0, 0, 0.5);
    color: #fff;
    border: none;
    width: 44px;
    height: 44px;
    line-height: 44px;
    border-radius: 50%;
    font-size: 26px;
    cursor: pointer;
    z-index: 10;
    display: flex;
    /* align-items: center; */
    text-align: center;
    justify-content: center;
}

.close-btn:hover {
    background: #f30;
}

.ys_tp .swiper-button-next,
.ys_tp .swiper-button-prev {
    color: #fff;
    width: 40px;
    height: 40px;
    background-color: rgba(0, 0, 0, 0.2);
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    transition: all 0.3s ease;
}

.ys_tp .swiper-button-next:hover,
.ys_tp .swiper-button-prev:hover {
    background-color: rgba(0, 0, 0, 0.4);
}

.icon-bofang {
    font-size: 40px;
}

/* 美化滚动条（可选，更美观） */
.j_s::-webkit-scrollbar {
    width: 6px;
}

.j_s::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 3px;
}

@media (max-width: 768px) {
    .video-modal-view {
        width: 100%;
        height: 35%;
    }
}
</style>